module.exports = __webpack_public_path__ + "brandon_light_it-webfont.95e095031e34a7de736b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_light_it-webfont.woff2
// module id = 942
// module chunks = 7